// extracted by mini-css-extract-plugin
export default {"InputRadio":"InputRadio__InputRadio___uAZPu","radio":"InputRadio__radio___OgdkI","label":"InputRadio__label___wba6_"};